var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-menu"},[_c('div',{staticClass:"h-100",attrs:{"data-simplebar":""}},[_c('div',{attrs:{"id":"sidebar-menu"}},[_c('sidebar-menu',{attrs:{"items":_vm.menu}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }